import { i18n } from "@lingui/core";
import { HomepageLink } from "@mobility-item-page/dealer/client";
import { trackHomepage } from "src/utils/pulseHelper.ts";
import { useOrganisation } from "../../context/DealerDataProviderContext.tsx";

export const Links = () => {
  const { name, homePage } = useOrganisation();
  if (!homePage) {
    return null;
  }
  return (
    <>
      <h2 className="t3 mt-40 mb-12">{i18n.t({ id: "dealerBrandingLayout.links.title", message: "Links" })}</h2>
      <ul>
        {homePage && (
          <li>
            <HomepageLink homePage={homePage} trackClick={() => trackHomepage(name, homePage.linkUrl)} />
          </li>
        )}
      </ul>
    </>
  );
};
